/**
 * IFRAP-AI.fr - Infographics Page
 * Display animated infographics from "Face au mur"
 */

import React, { useState, useEffect } from 'react';
import api from '../../api/client';
import { InfographicsGallery } from '../../components/AnimatedInfographic';
import { BarChart3, BookOpen, RefreshCw } from 'lucide-react';

const InfographicsPage = () => {
  const [infographics, setInfographics] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchInfographics();
  }, []);

  const fetchInfographics = async () => {
    try {
      setLoading(true);
      const res = await api.get('/api/knowledge/infographics');
      setInfographics(res.data.infographics || []);
    } catch (err) {
      console.error('Error fetching infographics:', err);
      setError('Erreur lors du chargement des infographies');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0f] py-12 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center gap-3 mb-4">
            <BarChart3 className="w-10 h-10 text-blue-500" />
            <h1 className="text-4xl font-bold text-white">Infographies IFRAP</h1>
          </div>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Visualisations interactives extraites de 
            <span className="text-blue-400 font-medium"> "Face au mur" </span>
            par Agnès Verdier-Molinié
          </p>
        </div>

        {/* Book reference */}
        <div className="bg-gradient-to-r from-blue-900/20 to-purple-900/20 border border-blue-500/20 rounded-xl p-6 mb-8 flex items-center gap-4">
          <BookOpen className="w-12 h-12 text-blue-400 flex-shrink-0" />
          <div>
            <h3 className="text-lg font-medium text-white">Source: Face au mur</h3>
            <p className="text-gray-400 text-sm">
              Les données proviennent du livre référence de la Fondation IFRAP, 
              publié en 2024, qui analyse en profondeur les finances publiques françaises.
            </p>
          </div>
        </div>

        {/* Content */}
        {loading ? (
          <div className="flex items-center justify-center py-20">
            <RefreshCw className="w-8 h-8 text-blue-500 animate-spin" />
          </div>
        ) : error ? (
          <div className="text-center py-20">
            <p className="text-red-400 mb-4">{error}</p>
            <button
              onClick={fetchInfographics}
              className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Réessayer
            </button>
          </div>
        ) : (
          <InfographicsGallery infographics={infographics} />
        )}

        {/* Footer note */}
        <div className="mt-12 text-center text-gray-600 text-sm">
          <p>
            Ces infographies sont générées automatiquement à partir des données 
            structurées extraites du livre.
          </p>
          <p className="mt-1">
            © Fondation IFRAP - Institut Français pour la Recherche sur les 
            Administrations et les Politiques Publiques
          </p>
        </div>
      </div>
    </div>
  );
};

export default InfographicsPage;
